import { Injectable } from '@angular/core';

@Injectable()
export class ThemesService {

    defaultTheme: string = 'A';

    constructor() {
        this.setTheme(this.defaultTheme);
    }

    setTheme(name: string) {
        // Remove any existing theme classes
        document.body.classList.remove('theme-a', 'theme-b', 'theme-c', 'theme-d', 'theme-e', 'theme-f', 'theme-g', 'theme-h');
        
        // Add the new theme class
        const themeClass = `theme-${name.toLowerCase()}`;
        document.body.classList.add(themeClass);
    }

    getDefaultTheme() {
        return this.defaultTheme;
    }

}
